import { FeatureToggles } from "@spartacus/core";

export const efaFeatureToggles: FeatureToggles = {
  authorizationCodeFlowByDefault: true,
  incrementProcessesCountForMergeCart: true,
  dispatchLoginActionOnlyWhenTokenReceived: true,
  cdsLoginEventsToken: true
}